export const isEmail = (text: string) => /^\S+@\S+\.\S{2,}$/.test(text);

export const isPhone = (text: string) =>
  /^[(]?[+]?[0-9]{0,1}-?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,8}$/.test(
    text
  );

export const isUsername = (text: string) => isEmail(text);
